import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { Skeleton } from "../ui/skeleton";
import { analyseProspect } from "../../apis/ext";

export default function Highlights({ contact_id, activeWorkspace, userId }) {
  const [keyPoints, setKeyPoints] = useState([]);
  const [negative, setNegative] = useState([]);
  const [positive, setPositive] = useState([]);

  const setPositiveNegative = (keyPoints) => {
    if (keyPoints && keyPoints.length > 0) {
      const positive = [];
      const negative = [];

      keyPoints.forEach((point) => {
        for (const [key, value] of Object.entries(point)) {
          if (key !== "sentiment") {
            const entry = {
              name: key,
              sentiment: point.sentiment,
              value: value,
            };

            if (point.sentiment === "positive") {
              positive.push(entry);
            } else if (point.sentiment === "negative") {
              negative.push(entry);
            }
          }
        }
      });

      const sortByEmptyValueFirst = (arr) => arr.sort((a, b) => (a.value === "" ? -1 : 1));

      const sortedPositive = sortByEmptyValueFirst(positive);
      const sortedNegative = sortByEmptyValueFirst(negative);

      console.log("Positive:", sortedPositive);
      setPositive(sortedPositive);
      setNegative(sortedNegative);
      console.log("Negative:", sortedNegative);
    }
  };
  const analyseProspectFn = useMutation("analyse_prospect", analyseProspect, {
    onSuccess(data, variables, context) {
      console.log(data);
      setKeyPoints(data?.key_points);

      setPositiveNegative(data?.key_points);
      localStorage.setItem(
        `${userId}_${contact_id}_${activeWorkspace?.id}_keypoints`,
        JSON.stringify(data?.key_points)
      );
    },
    onError(error) {
      console.log(error);
    },
  });
  const handleAnalyseProspect = () => {
    if (localStorage.getItem(`${userId}_${contact_id}_${activeWorkspace?.id}_keypoints`)) {
      setKeyPoints(
        JSON.parse(localStorage.getItem(`${userId}_${contact_id}_${activeWorkspace?.id}_keypoints`))
      );
      setPositiveNegative(
        JSON.parse(localStorage.getItem(`${userId}_${contact_id}_${activeWorkspace?.id}_keypoints`))
      );
      return;
    }
    if (analyseProspectFn.isLoading) {
      return;
    } else {
      analyseProspectFn.mutate({
        data: {
          contact_id: contact_id,
        },
        options: {
          headers: { "X-Workspace-Id": activeWorkspace?.id },
        },
      });
    }
  };
  useEffect(() => {
    handleAnalyseProspect();
  }, []);
  return (
    <>
      {analyseProspectFn.isLoading && keyPoints && keyPoints.length === 0 && (
        <>
          <div className="border   rounded-[14px] overflow-hidden border-input  bg-background relative">
            <div className="flex pt-4 pb-3 px-4 justify-between items-center ">
              <div className="inline-flex items-center">
                <span className="text-[16px] text-text-700 mr-2 font-semibold leading-none ">Positive</span>
              </div>
            </div>
            <div className="px-4 mb-4">
              <div className="flex flex-wrap">
                <Skeleton className="h-6 w-24 mb-2" />
                <Skeleton className="h-6 w-16 mb-2 ml-2" />
                <Skeleton className="h-6 w-16 mb-2 ml-2" />
              </div>
              <div className="flex flex-wrap">
                <Skeleton className="h-6 w-24 mb-2" />
                <Skeleton className="h-6 w-16 mb-2 ml-2" />
                <Skeleton className="h-6 w-16 mb-2 ml-2" />
              </div>
            </div>
          </div>
          <div className="border   rounded-[14px] overflow-hidden border-input  bg-background relative mt-4">
            <div className="flex pt-4 pb-3 px-4 justify-between items-center ">
              <div className="inline-flex items-center">
                <span className="text-[16px] text-text-700 mr-2 font-semibold leading-none ">Negative</span>
              </div>
            </div>
            <div className="px-4 mb-4">
              <div className="flex flex-wrap">
                <Skeleton className="h-6 w-24 mb-2" />
                <Skeleton className="h-6 w-16 mb-2 ml-2" />
                <Skeleton className="h-6 w-16 mb-2 ml-2" />
              </div>
              <div className="flex flex-wrap">
                <Skeleton className="h-6 w-24 mb-2" />
                <Skeleton className="h-6 w-16 mb-2 ml-2" />
                <Skeleton className="h-6 w-16 mb-2 ml-2" />
              </div>
            </div>
          </div>
        </>
      )}
      {!analyseProspectFn.isLoading && keyPoints && keyPoints.length > 0 && (
        <>
          {positive && positive.length > 0 && (
            <div className="border   rounded-[14px] overflow-hidden border-input  bg-background relative ">
              <div className="flex pt-4 pb-3 px-4 justify-between items-center ">
                <div className="inline-flex items-center">
                  <span className="text-[16px] text-text-700 mr-2 font-semibold leading-none ">
                    Positive
                  </span>
                </div>
              </div>
              <div className="px-4 mb-4 highlight__details__wrapper">
                {positive &&
                  positive.length > 0 &&
                  (() => {
                    let firstNonEmptyValue = true;
                    if (positive.some((item) => item.value === "")) {
                      firstNonEmptyValue = true;
                    } else {
                      firstNonEmptyValue = false;
                    }
                    return positive.map((item, index) => (
                      <React.Fragment key={index}>
                        {item.value === "" ? (
                          <span
                            className={`inline-block highlight__details__normal mt-2 mr-2 text-[14px] border px-2.5 py-1 rounded-lg bg-success-50 text-success-700 border-success-200`}
                          >
                            {item?.name}
                          </span>
                        ) : (
                          <>
                            {firstNonEmptyValue && (
                              <div className="h-[1px] border-b my-5 w-10/12 mx-auto"></div>
                            )}
                            <span
                              className={`highlight__details block mt-2 text-[14px] border px-2.5 py-2 rounded-lg bg-success-50 text-success-700 border-success-200 `}
                            >
                              {(firstNonEmptyValue = false)}
                              <span className="font-bold block mb-1.5">{item?.name}</span>
                              <span className="block">{item.value}</span>
                            </span>
                          </>
                        )}
                      </React.Fragment>
                    ));
                  })()}
              </div>
            </div>
          )}
          {negative && negative.length > 0 && (
            <div className="border   rounded-[14px] overflow-hidden border-input  bg-background relative mt-4 ">
              <div className="flex pt-4 pb-3 px-4 justify-between items-center ">
                <div className="inline-flex items-center">
                  <span className="text-[16px] text-text-700 mr-2 font-semibold leading-none ">
                    Negative
                  </span>
                </div>
              </div>
              <div className="px-4 mb-4 highlight__details__wrapper">
                {negative &&
                  negative.length > 0 &&
                  (() => {
                    let firstNonEmptyValue = true;
                    if (negative.some((item) => item.value === "")) {
                      firstNonEmptyValue = true;
                    } else {
                      firstNonEmptyValue = false;
                    }
                    return negative.map((item, index) => (
                      <React.Fragment key={index}>
                        {item.value === "" ? (
                          <span
                            className={`inline-block highlight__details__normal mt-2 mr-2 text-[14px] border px-2.5 py-1 rounded-lg bg-warning-50 text-warning-700 border-warning-200`}
                          >
                            {item?.name}
                          </span>
                        ) : (
                          <>
                            {firstNonEmptyValue && (
                              <div className="h-[1px] border-b my-5 w-10/12 mx-auto"></div>
                            )}
                            <span
                              className={`highlight__details block mt-2 text-[14px] border px-2.5 py-2 rounded-lg bg-warning-50 text-warning-700 border-warning-200 `}
                            >
                              {(firstNonEmptyValue = false)}
                              <span className="font-bold block mb-1.5">{item?.name}</span>
                              <span className="block">{item.value}</span>
                            </span>
                          </>
                        )}
                      </React.Fragment>
                    ));
                  })()}
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}
